export const required = (value) => {
  if (value) {
    if (typeof value === 'string' && !value.replace(/\s/g, '').length) {
      return 'Field contains only spaces';
    }
    return undefined;
  }
  return 'Field is required';
};

export const socialSecurityNumber = value => (
  value && !/^[0-9]{3}?[-]{1}?[0-9]{2}[-]{1}?[0-9]{4}$/i.test(value)
    ? 'Invalid Social Security Number'
    : undefined
);

export const date = value => (
  value && !/^([0-9]|0[1-9]|1[012])[/]([0-9]|0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/i.test(value)
    ? 'Invalid Date'
    : undefined
);

export const time = value => (
  value && !/^([0-9]|0[0-9]|1[0-2])[:][0-6][0-9][\s][ap][m]$/i.test(value)
    ? 'Invalid Time'
    : undefined
);

export const timeOfDelivery = value => (
  value && (!/^([89]|0[89]|1[0-1])[:][0-6][0-9][\s][a][m]$/i.test(value)
    && !/^([1-7]|0[1-7]|12)[:][0-6][0-9][\s][p][m]$/i.test(value))
    ? 'Time of Delivery should be from 8am to 8pm'
    : undefined
);

export const phone = value => (
  value
    && value.replace('+1', '').trim().length > 0
    && !/^[+]{1}[1]{1}[\s]{1}[(]{1}[0-9]{3}[)]{1}[\s]{1}[0-9]{3}[-]{1}[0-9]{4}$/i.test(value)
    ? 'Invalid Phone Number'
    : undefined
);

export const email = value => (
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(value)
    ? 'Invalid email address'
    : undefined
);

export const zip = value => (
  value && !/^\d{5}(-\d{4})?$/i.test(value)
    ? 'Invalid zip code'
    : undefined
);

export const cardNumber = value => (
  value && !/^[0-9]{4}?[ ]{1}?[0-9]{4}[ ]{1}?[0-9]{4}[ ]{1}?[0-9]{3,4}$/i.test(value)
    ? 'Invalid Card Number'
    : undefined
);

export const cardExpiration = value => (
  value && !/^(0[1-9]|1[012])[/][\d]{2}$/i.test(value)
    ? 'Invalid Date'
    : undefined
);

export const cardCVV = value => (
  value && !/^[\d]{3,4}$/i.test(value)
    ? 'Invalid CVV'
    : undefined
);

export const minLength10 = value => (
  !value || value.length >= 10 || value.length === 0
    ? undefined
    : 'Value is shorter than 10 characters'
);

export const minLength8 = value => (
  !value || value.length >= 8 || value.length === 0
    ? undefined
    : 'Value is shorter than 8 characters'
);

export const minLength4 = value => (
  !value || value.length >= 4 || value.length === 0
    ? undefined
    : 'Value is shorter than 4 characters'
);

export const minLength2 = value => (
  !value || value.length >= 2 || value.length === 0
    ? undefined
    : 'Value is shorter than 2 characters'
);

export const containsLowercaseAlphabetical = value => (
  value && !/[a-z]/.test(value)
    ? 'Must contain at least 1 lowercase letter'
    : undefined
);

export const containsUppercaseAlphabetical = value => (
  value && !/[A-Z]/.test(value)
    ? 'Must contain at least 1 uppercase letter'
    : undefined
);

export const containsNumber = value => (
  value && !/[0-9]/.test(value)
    ? 'Must contain at least 1 number'
    : undefined
);

export const containsSpecialChar = value => (
  value && !/[`~$&+,:;=?@#|'"<>.\-_^*()[\]{}%!\\/]/.test(value)
    ? 'Must contain at least 1 special character'
    : undefined
);

export const password = value => (
  value && (minLength8(value)
    || containsLowercaseAlphabetical(value)
    || containsUppercaseAlphabetical(value)
    || containsNumber(value)
    || containsSpecialChar(value))
    ? `Password must contain a lowercase letter,
    uppercase letter, number, symbol
    and be longer than 8 characters`
    : undefined
);

export const noCyrillic = value => (
  value && /[а-яА-ЯЁё]/.test(value)
    ? 'Cyrillic symbols are not allowed'
    : undefined
);

export const hcpcCode = value => (
  value && (value.length < 5 || !/^[A-Z]+\d{1,4}$/i.test(value))
    ? 'Invalid HCPCS Code format'
    : undefined
);

export const resubmissionCode = value => (
  value && ['1', '7', '8'].indexOf(value) === -1
    ? 'Incorrect Resubmission Code'
    : undefined
);



// WEBPACK FOOTER //
// ./src/utils/validate.js